import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { DIALOG_MESSAGE as CORE_DIALOG, TIMER_TIMEOUT } from '~/core/constants';
import { useTimer } from '~/core/composables/useTimer';
import EnterMail from '~/core/components/ConfirmMail/enterMail.vue';
import EnterCode from '~/core/components/ConfirmMail/enterCode.vue';
import { blockedDomainRegExp } from '~/core/constants/regex';
import useMainDialogStore from '~/stores/useMainDialogStore';
import useLocaleStore from '~/stores/useLocaleStore';
import { MailStatus } from '~/features/Profile/enums';
export default defineComponent({
  name: 'ConfirmMailForm',
  components: {
    EnterCode: EnterCode,
    EnterMail: EnterMail
  },
  props: {
    onlyConfirmationEmail: {
      type: String,
      default: ''
    },
    onlyConfirmation: {
      type: Boolean,
      default: false
    },
    hideOnlyConfirmationSupport: {
      type: Boolean,
      default: false
    },
    mailLoading: {
      type: Boolean,
      default: false
    },
    codeLoading: {
      type: Boolean,
      default: false
    },
    emailLabel: {
      type: String,
      default: 'Электронная почта'
    },
    // reject должен возвращать ошибки бекенда
    requestCallback: {
      type: Function,
      required: true
    },
    // reject должен возвращать ошибки бекенда
    confirmCallback: {
      type: Function,
      required: true
    },
    resendTimeout: {
      type: Number,
      default: TIMER_TIMEOUT
    },
    dailyLimit: {
      type: Boolean,
      default: false
    }
  },
  emits: ['email:confirmed', 'update:resend-timeout', 'click:reset'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var locale = useLocaleStore();
    var enterMail = ref(null);
    var enterCode = ref(null);
    var step = ref(MailStatus.Mail);
    var currentMail = ref('');
    var errorMail = ref('');
    var errorCode = ref('');
    var isMailLoading = ref(false);
    var isEnterCodeLoading = ref(false);
    var isInnerDailyLimit = ref(false);
    var $dialog = useMainDialogStore();
    var _useTimer = useTimer(),
      codeTimer = _useTimer.codeTimer,
      formattedTimer = _useTimer.formattedTimer,
      startCodeTimer = _useTimer.startCodeTimer,
      clearTimer = _useTimer.clearTimer;

    // TODO[wff_remove_foreign_email_validation]: удалить константу rules
    var rules = locale.isRu ? [function (v) {
      return !blockedDomainRegExp.test(v.trim()) || 'Почта не должна быть на иностранном сервисе';
    }] : [];
    watch(codeTimer, function (val) {
      if (val !== null) {
        emit('update:resend-timeout', val);
      }
    });
    onBeforeMount(function () {
      step.value = props.onlyConfirmation ? MailStatus.Sent : MailStatus.Mail;
      if (props.onlyConfirmation) {
        currentMail.value = props.onlyConfirmationEmail;
        startCodeTimer(props.resendTimeout);
      }
    });
    onMounted(function () {
      resetValidations();
    });
    onBeforeUnmount(function () {
      resetData();
      clearTimer();
    });
    function resetData() {
      step.value = MailStatus.Mail;
      currentMail.value = '';
      errorMail.value = '';
      errorCode.value = '';
    }
    function isCurrentStep(checkableStep) {
      return step.value === checkableStep;
    }
    function handleChangeEmail() {
      resetError();
      clearTimer();
      step.value = MailStatus.Mail;
      resetValidations();
    }
    function handleClickNoAccessMail() {
      emit('click:reset');
    }
    function resetMailError() {
      errorMail.value = '';
    }
    function resetCodeError() {
      if (errorCode.value === MailStatus.DailyLimit) {
        isInnerDailyLimit.value = errorCode.value === MailStatus.DailyLimit;
        return;
      }
      if ([MailStatus.Expired, MailStatus.AttemptsOut].includes(errorCode.value)) {
        return;
      }
      errorCode.value = '';
    }
    function handleSendingError(_ref2, errorField) {
      var _response$data, _response$data$errorF;
      var response = _ref2.response;
      var code = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$errorF = _response$data[errorField]) === null || _response$data$errorF === void 0 ? void 0 : _response$data$errorF.code;
      if (code) {
        errorMail.value = code;
        errorCode.value = code;
        return;
      }
      $dialog.open(_objectSpread({}, CORE_DIALOG.GLOBAL_ERROR));
    }
    function handleSendMail() {
      return _handleSendMail.apply(this, arguments);
    }
    function _handleSendMail() {
      _handleSendMail = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              isMailLoading.value = true;
              _context.next = 4;
              return props.requestCallback({
                email: currentMail.value
              });
            case 4:
              step.value = MailStatus.Sent;
              resetError();
              startCodeTimer();
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              handleSendingError(_context.t0, 'email');
            case 12:
              _context.prev = 12;
              isMailLoading.value = false;
              return _context.finish(12);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9, 12, 15]]);
      }));
      return _handleSendMail.apply(this, arguments);
    }
    function handleConfirmMail(_x) {
      return _handleConfirmMail.apply(this, arguments);
    }
    function _handleConfirmMail() {
      _handleConfirmMail = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(secretCode) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              isEnterCodeLoading.value = true;
              _context2.next = 4;
              return props.confirmCallback({
                email: currentMail.value,
                secretCode: secretCode
              });
            case 4:
              emit('email:confirmed');
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              handleSendingError(_context2.t0, 'secret_code');
            case 10:
              _context2.prev = 10;
              isEnterCodeLoading.value = false;
              return _context2.finish(10);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 7, 10, 13]]);
      }));
      return _handleConfirmMail.apply(this, arguments);
    }
    function resetError() {
      isInnerDailyLimit.value = false;
      errorMail.value = '';
      errorCode.value = '';
    }
    function resetValidations() {
      var _enterMail$value, _enterMail$value$$ref, _enterCode$value, _enterCode$value$$ref;
      (_enterMail$value = enterMail.value) === null || _enterMail$value === void 0 ? void 0 : (_enterMail$value$$ref = _enterMail$value.$refs.form) === null || _enterMail$value$$ref === void 0 ? void 0 : _enterMail$value$$ref.resetValidation();
      (_enterCode$value = enterCode.value) === null || _enterCode$value === void 0 ? void 0 : (_enterCode$value$$ref = _enterCode$value.$refs.form) === null || _enterCode$value$$ref === void 0 ? void 0 : _enterCode$value$$ref.resetValidation();
    }
    return {
      rules: rules,
      isInnerDailyLimit: isInnerDailyLimit,
      MailStatus: MailStatus,
      enterMail: enterMail,
      enterCode: enterCode,
      step: step,
      currentMail: currentMail,
      errorMail: errorMail,
      errorCode: errorCode,
      isMailLoading: isMailLoading,
      isEnterCodeLoading: isEnterCodeLoading,
      formattedTimer: formattedTimer,
      isCurrentStep: isCurrentStep,
      handleChangeEmail: handleChangeEmail,
      handleClickNoAccessMail: handleClickNoAccessMail,
      resetMailError: resetMailError,
      resetCodeError: resetCodeError,
      handleSendMail: handleSendMail,
      handleConfirmMail: handleConfirmMail
    };
  }
});